module.exports = __webpack_public_path__ + "static/media/Desafio3-c.b6067d8a.mp4";